import { ReducedUser } from '@/types/user';
import { Get, Post } from './helpers';

export const SetAdminPassword = async (password: string, hashCode: string): Promise<boolean> => {
  return Post<boolean>({ url: '/v3/admin/auth/set-password', body: { hashCode, password }, ignoreResponse: true });
};

export const GetAccountFromStoredSession = async (stored_token: string): Promise<{ account: ReducedUser }> => {
  return Get<{ account: ReducedUser }>({
    url: `/v3/admin/auth/account-from-token`,
    headers: { Authorization: `Bearer ${stored_token}` },
  });
};
